// extracted by mini-css-extract-plugin
module.exports = {"root":"slideshow-module--root--3suil","nav":"slideshow-module--nav--1QdOw","carousel":"slideshow-module--carousel--1tMRj","slide":"slideshow-module--slide--3oZKH"};